/**
 * 그래프 시각화 전용 error boundary.
 *
 * 시각화는 외부 canvas 라이브러리에 기댄다. 그 라이브러리가 죽더라도 **탭 전체가 사라지면
 * 안 된다.** 내용은 여전히 봐야 하므로 텍스트 대체 화면으로 떨어진다.
 *
 * 실제로 `@neo4j-nvl/react` 가 React 사본을 따로 끌고 와 hook dispatcher 가 null 이 되어
 * 탭이 통째로 빈 적이 있다 (vite `resolve.dedupe` 로 고쳤다).
 */

import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback: ReactNode;
}

interface State {
  failed: boolean;
}

export class GraphErrorBoundary extends Component<Props, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // 개발자 확인용. 사용자에게는 대체 화면만 보인다.
    console.error("그래프 시각화 실패", error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.failed) {
      return (
        <div className="graph-fallback">
          <p className="notice" role="status">
            <span aria-hidden="true">⚠</span> 그래프를 그리지 못해 목록으로 보여 줍니다.
          </p>
          {this.props.fallback}
        </div>
      );
    }
    return this.props.children;
  }
}
